module.exports = __webpack_public_path__ + "frontend/images/faq/screen-promo-06685cedadb5999e3b9327950d4e6dc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/faq/screen-promo.jpg
// module id = 337
// module chunks = 2